module.exports = __webpack_public_path__ + "static/media/0029_IMG_LE_PLAFOND_RAL_9010.4d58c05b.png";